export const playWhisperStream = async (response) => {
  const reader = response.body.getReader();
  const audioContext = new (window.AudioContext || window.webkitAudioContext)();
  let chunks = []; // Array to hold the Uint8Array chunks

  const processStream = async ({ done, value }) => {
    if (done) {
      const audioBuffer = new Uint8Array(
        chunks.reduce((acc, val) => acc.concat(Array.from(val)), [])
      ).buffer;
      try {
        const decodedData = await audioContext.decodeAudioData(audioBuffer);
        const source = audioContext.createBufferSource();
        source.buffer = decodedData;
        source.connect(audioContext.destination);
        source.start();
      } catch (e) {
        console.error("Error decoding audio data", e);
      }
      return;
    }
    chunks.push(value);
    return reader.read().then(processStream); // Continue reading the stream recursively
  };

  reader
    .read()
    .then(processStream)
    .catch((e) => console.error("Stream reading error", e));
};

export const speakWithWhisper = async (text) => {
  try {
    const response = await fetch(`https://htmaaland-3c97b27faa21.herokuapp.com/whisper-tts`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ text }),
    });
    if (response.ok) {
      playWhisperStream(response);
    } else {
      console.error("Server responded with an error");
    }
  } catch (e) {
    console.error("Error using Whisper TTS: ", e);
  }
};
